export default __webpack_public_path__ + "static/media/Blog16.caa29f10.png";